(function () {
  var SECTION_SELECTOR = '.oddit-section-bundle-builder';
  /* The flavour cards became flavour rows when the picker moved into the panel.
     Everything here keys off the attribute rather than the class, so the markup
     can be restyled again without the script chasing it. */
  var ROW_SELECTOR = '[data-flavor-row]';
  var sectionState = new Map();

  /* ── Currency ─────────────────────────────────────────────────
     Prices are computed from the variants themselves now, so everything below
     works in cents and formats once at the edge. Same approach as the cart
     drawer, so the two agree on how a total reads. */

  function activeCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function formatMoney(cents) {
    var currency = activeCurrency();
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function intAttr(el, name, fallback) {
    if (!el) return fallback;
    var n = parseInt(el.getAttribute(name), 10);
    return isNaN(n) ? fallback : n;
  }

  /* ── Setup ────────────────────────────────────────────────── */

  function initSection(section) {
    var state = {
      section: section,
      /* productId -> quantity. Replaces the old flat list of picks: a flavour
         can now be in the bundle more than once, and the card shows how many. */
      quantities: {},
      frequency: 'subscribe',
      tiers: readTiers(section),
      minQuantity: intAttr(section, 'data-min-quantity', 0),
      maxQuantity: intAttr(section, 'data-max-quantity', 0),
      subscriptionDiscount: intAttr(section, 'data-subscription-discount', 0),
      unitNoun: section.getAttribute('data-unit-noun') || 'item',
      unitNounPlural: section.getAttribute('data-unit-noun-plural') || 'items'
    };

    /* The top tier is the natural ceiling — past it nothing more is unlocked,
       so an unset maximum stops there rather than running away. */
    if (!state.maxQuantity && state.tiers.length) {
      state.maxQuantity = state.tiers[state.tiers.length - 1].min;
    }

    sectionState.set(section, state);

    initProductCards(section, state);
    initGallery(section);
    initFrequencySelector(section, state);
    initAccordions(section);
    initCTA(section, state);
    initVarietyAdd(section);

    render(section, state);

    /* A shopper arriving from a flavour card elsewhere (e.g. the homepage
       featured collection) carries the flavour in ?flavor=<product-handle>.
       Show it in the gallery — a soft pre-select that highlights the flavour
       without adding anything to the bundle. */
    preselectFlavorFromUrl(section);

    /* The cart, not this panel, is where the bundle actually lives now — so a
       shopper who reloads or comes back from another page picks up where they
       left off instead of facing an empty builder that would then add a second
       copy of everything. */
    hydrateFromCart(section, state);
  }

  /* The tier ladder is markup, not a JS constant — the merchant owns it through
     the section's blocks. Sorted ascending so "current" and "next" are just a
     walk up the list. */
  function readTiers(section) {
    var marks = section.querySelectorAll('[data-tier-mark]');
    var tiers = [];
    for (var i = 0; i < marks.length; i++) {
      var min = intAttr(marks[i], 'data-tier-min', 0);
      if (min <= 0) continue;
      /* Each tier carries both purchase types. Subscribe falls back to the
         one-time figures where it has none of its own, so a tier configured
         before the split still prices the same for both. */
      var onePct = intAttr(marks[i], 'data-tier-percent', 0);
      var subPct = intAttr(marks[i], 'data-tier-percent-subscribe', 0);
      var oneCode = marks[i].getAttribute('data-tier-discount-code') || '';
      var subCode = marks[i].getAttribute('data-tier-discount-code-subscribe') || '';
      tiers.push({
        min: min,
        percent: onePct,
        percentSubscribe: subPct > 0 ? subPct : onePct,
        label: marks[i].getAttribute('data-tier-label') || '',
        freeShipping: marks[i].getAttribute('data-tier-free-shipping') === 'true',
        freeShippingSubscribe: marks[i].getAttribute('data-tier-free-shipping-subscribe') === 'true',
        discountCode: oneCode,
        discountCodeSubscribe: subCode || oneCode,
        el: marks[i]
      });
    }
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }

  function initCTA(section, state) {
    var ctaBtn = section.querySelector('.oddit-section-bundle-builder__cta-button');
    if (!ctaBtn) return;
    ctaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      handleCheckout(section, state);
    });
  }

  function initProductCards(section, state) {
    var rows = section.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i++) {
      bindCard(section, state, rows[i]);
    }

    /* The whole row selects the flavour, not just its 52px thumbnail. The row
       looks like one control and reads like one, so only part of it responding
       to a click was the odd thing.

       The row stays a plain div: it holds the quantity buttons, and interactive
       controls cannot be nested inside a role="button" without breaking both.
       So this is a pointer convenience layered on top — the thumbnail keeps its
       button semantics and its aria-label, and remains what keyboard and screen
       reader users operate. */
    for (var r = 0; r < rows.length; r++) {
      rows[r].addEventListener('click', handleRowClick.bind(null, section));
    }
  }

  /* Clicks inside the quantity control are about how many, not which — stepping
     2 to 3 should not also swap the gallery. Everything else in the row selects.
     (Adding a flavour for the first time does bring its pack shot up, but that
     is handled in changeQuantity, which knows it is a 0 -> 1 transition.) */
  function handleRowClick(section, e) {
    if (e.target.closest && e.target.closest('[data-flavor-control]')) return;
    selectFlavorRow(section, e.currentTarget);
  }

  function bindCard(section, state, card) {
    var productId = card.getAttribute('data-product-id');
    if (!productId) return;

    var addBtn = card.querySelector('[data-add-flavor]');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        changeQuantity(section, state, productId, 1);
      });
    }

    var incBtn = card.querySelector('[data-qty-increase]');
    if (incBtn) {
      incBtn.addEventListener('click', function (e) {
        e.preventDefault();
        changeQuantity(section, state, productId, 1);
      });
    }

    var decBtn = card.querySelector('[data-qty-decrease]');
    if (decBtn) {
      decBtn.addEventListener('click', function (e) {
        e.preventDefault();
        changeQuantity(section, state, productId, -1);
      });
    }
  }

  function selectFlavorRow(section, card) {
    if (!card) return;

    var productId = card.getAttribute('data-product-id');
    if (!productId) return;

    /* The row puts this flavour in the gallery — the two lists are built from
       the same blocks in the same order, so the row carries the frame index
       outright. */
    showGalleryFrame(section, intAttr(card, 'data-gallery-index', -1));
    markSelectedRow(section, card);

    if (typeof window.CustomEvent !== 'function') return;

    document.dispatchEvent(
      new CustomEvent('oddit:bundle-flavor-selected', {
        detail: {
          productId: productId,
          productTitle: card.getAttribute('data-product-title') || ''
        }
      })
    );
  }

  /* Which flavour the gallery is showing. Distinct from being IN the bundle,
     which the row already signals by tinting itself — a shopper looks at a
     flavour before deciding, and the gallery has to say which one it is
     currently showing. */
  function markSelectedRow(section, card) {
    var rows = section.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i++) {
      var on = rows[i] === card;
      rows[i].classList.toggle('is-selected', on);
      rows[i].setAttribute('aria-current', on ? 'true' : 'false');
    }
  }

  /* Soft pre-select from ?flavor=<product-handle>. Finds the matching row and
     triggers its select-flavour thumb, so the flavour shows in the gallery
     exactly as a click would — nothing is added to the bundle. Unknown or
     missing handles are a no-op. */
  function preselectFlavorFromUrl(section) {
    try {
      if (typeof URLSearchParams !== 'function') return;
      var flavor = new URLSearchParams(window.location.search).get('flavor');
      if (!flavor) return;

      var rows = section.querySelectorAll(ROW_SELECTOR);
      for (var i = 0; i < rows.length; i++) {
        /* The flavour slug first: with the flavours as variants of one parent,
           every row reports the same product handle, so matching on that alone
           preselected the first row for any flavour asked for. The product
           handle stays as the fallback for the one-product-per-flavour shape. */
        if (rows[i].getAttribute('data-flavor-handle') === flavor ||
            rows[i].getAttribute('data-product-handle') === flavor) {
          selectFlavorRow(section, rows[i]);
          if (rows[i].scrollIntoView) {
            rows[i].scrollIntoView({ block: 'nearest' });
          }
          return;
        }
      }
    } catch (e) {}
  }

  /* ── Gallery ──────────────────────────────────────────────────
     One frame per flavour, assembled in Liquid from the same product_card
     blocks the rows come from. Only one is ever in the layout, so the column
     cannot resize as the shopper flicks through. */

  /* The strip used to be one thumbnail per FLAVOUR, so it repeated the flavour
     list and gave no way to see a second angle of the product being bought. It
     is now the selected flavour's own images: choosing a flavour swaps the whole
     set, and the thumbnails page within it. A frame is therefore addressed by
     two indices — which flavour, and which of its images. */
  function initGallery(section) {
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function (e) {
        e.preventDefault();
        showGalleryImage(section, intAttr(e.currentTarget, 'data-gallery-thumb', -1));
      });
    }
  }

  function activeFlavorIndex(section) {
    var gallery = section.querySelector('[data-gallery]');
    return gallery ? intAttr(gallery, 'data-active-flavor', 0) : 0;
  }

  /* Switching flavour always lands on that flavour's first image, so the frame
     on screen is one the shopper can be sure belongs to what they just picked
     rather than whatever slot they happened to be on. */
  function showGalleryFrame(section, flavorIndex) {
    if (flavorIndex < 0) return;

    var gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;
    gallery.setAttribute('data-active-flavor', String(flavorIndex));

    /* One strip per flavour; only the selected one is in the layout. */
    var groups = section.querySelectorAll('[data-thumb-group]');
    for (var g = 0; g < groups.length; g++) {
      groups[g].hidden = intAttr(groups[g], 'data-thumb-group', -1) !== flavorIndex;
    }

    /* The header rating follows the gallery: the flavour on screen is the one
       whose stars are shown. Rendered per flavour in Liquid, so this only picks
       which is in the layout. */
    var ratings = section.querySelectorAll('[data-flavor-rating]');
    for (var r = 0; r < ratings.length; r++) {
      ratings[r].hidden = intAttr(ratings[r], 'data-flavor-rating', -1) !== flavorIndex;
    }

    showGalleryImage(section, 0);
  }

  function showGalleryImage(section, imageIndex) {
    if (imageIndex < 0) return;

    var flavorIndex = activeFlavorIndex(section);

    var frames = section.querySelectorAll('[data-gallery-frame]');
    if (!frames.length) return;

    var matched = false;
    for (var i = 0; i < frames.length; i++) {
      var on =
        intAttr(frames[i], 'data-gallery-frame', -1) === flavorIndex &&
        intAttr(frames[i], 'data-image-index', -1) === imageIndex;
      frames[i].hidden = !on;
      if (on) matched = true;
    }

    /* A flavour can have fewer images than the one before it, so an index that
       was valid a moment ago may not exist here. Fall back to its first frame
       rather than hiding every one and collapsing the column. */
    if (!matched) {
      for (var f = 0; f < frames.length; f++) {
        if (
          intAttr(frames[f], 'data-gallery-frame', -1) === flavorIndex &&
          intAttr(frames[f], 'data-image-index', -1) === 0
        ) {
          frames[f].hidden = false;
          imageIndex = 0;
          break;
        }
      }
    }

    var group = section.querySelector('[data-thumb-group="' + flavorIndex + '"]');
    var thumbs = group ? group.querySelectorAll('[data-gallery-thumb]') : [];
    for (var t = 0; t < thumbs.length; t++) {
      var active = intAttr(thumbs[t], 'data-gallery-thumb', -1) === imageIndex;
      thumbs[t].classList.toggle('is-active', active);
      thumbs[t].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  /* The variety pack is a finished product, not part of the bundle, so it is
     the one thing here that still adds itself straight to the cart. (It carried
     a data-variant-id and nothing else — no listener was ever bound to it, so
     clicking it did nothing at all.) */
  function initVarietyAdd(section) {
    var btn = section.querySelector('.oddit-section-bundle-builder__variety-add');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      btn.classList.add('is-loading');

      postJSON('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
        .then(function () {
          showBundleError(section, '');
          /* Refresh so the header count moves; never open — the drawer sliding
             over the builder is exactly what the theme setting turns off. */
          if (window.OdditCartDrawer && window.OdditCartDrawer.refreshCart) {
            return window.OdditCartDrawer.refreshCart();
          }
        })
        .catch(function (err) {
          showBundleError(section, err && err.message ? err.message : 'Add to cart failed.');
          if (window.console) console.error('[bundle-builder]', err);
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  /* ── Quantities ───────────────────────────────────────────── */

  function cardFor(section, productId) {
    return section.querySelector(
      ROW_SELECTOR + '[data-product-id="' + productId + '"]'
    );
  }

  function totalQuantity(state) {
    var total = 0;
    for (var key in state.quantities) {
      if (Object.prototype.hasOwnProperty.call(state.quantities, key)) {
        total += state.quantities[key];
      }
    }
    return total;
  }

  function changeQuantity(section, state, productId, delta) {
    var card = cardFor(section, productId);
    if (!card) return;

    /* A sold-out flavour cannot go in the bundle — /cart/add.js rejects the
       whole payload with a 422, so one unavailable pick killed the add. */
    if (delta > 0 && card.getAttribute('data-available') === 'false') return;

    if (delta > 0 && state.maxQuantity > 0 && totalQuantity(state) >= state.maxQuantity) return;

    var current = state.quantities[productId] || 0;
    var next = current + delta;
    if (next < 0) next = 0;

    if (next === 0) {
      delete state.quantities[productId];
    } else {
      state.quantities[productId] = next;
    }

    /* Bringing a flavour into the bundle for the first time brings its pack shot
       up with it. Only on 0 → 1: stepping an existing flavour from 2 to 3 should
       not yank the gallery away from whatever the shopper is looking at. */
    if (current === 0 && next === 1) {
      showGalleryFrame(section, intAttr(card, 'data-gallery-index', -1));
    }

    render(section, state);
    scheduleCartSync(section, state);
  }

  function setQuantity(section, state, productId, qty) {
    var current = state.quantities[productId] || 0;
    if (qty === current) return;

    /* Straight to the target rather than one step at a time: the per-step cap
       in changeQuantity would stop a jump short and silently land on a
       different number than the caller asked for. */
    if (qty <= 0) {
      delete state.quantities[productId];
    } else {
      var card = cardFor(section, productId);
      if (!card || card.getAttribute('data-available') === 'false') return;

      var headroom = state.maxQuantity > 0
        ? state.maxQuantity - (totalQuantity(state) - current)
        : qty;
      state.quantities[productId] = Math.min(qty, Math.max(headroom, 0));
      if (!state.quantities[productId]) delete state.quantities[productId];
    }

    render(section, state);
    scheduleCartSync(section, state);
  }

  /* ── Render ───────────────────────────────────────────────── */

  function render(section, state) {
    updateCards(section, state);
    updateTierProgress(section, state);
    updateSubscribeCopy(section, state);
    updatePricing(section, state);
    updateCTAButton(section, state);
    announceUpdate(section, state);
  }

  /* Everything downstream of the builder — the single-flavour PDP below it, most
     obviously — used to read the builder's DOM to work out what was selected.
     One event and one small API instead, so the two are not welded together. */
  function announceUpdate(section, state) {
    if (typeof window.CustomEvent !== 'function') return;
    var total = totalQuantity(state);
    document.dispatchEvent(
      new CustomEvent('oddit:bundle-updated', {
        detail: {
          section: section,
          total: total,
          max: state.maxQuantity,
          isFull: state.maxQuantity > 0 && total >= state.maxQuantity
        }
      })
    );
  }

  function updateCards(section, state) {
    var total = totalQuantity(state);
    var isFull = state.maxQuantity > 0 && total >= state.maxQuantity;
    var cards = section.querySelectorAll(ROW_SELECTOR);

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var productId = card.getAttribute('data-product-id');
      var qty = state.quantities[productId] || 0;
      var available = card.getAttribute('data-available') !== 'false';

      var addBtn = card.querySelector('[data-add-flavor]');
      var stepper = card.querySelector('[data-flavor-stepper]');

      card.classList.toggle('is-in-bundle', qty > 0);

      /* An ADD button is still supported for any markup that has one, but the
         row shows a permanent stepper instead: in a row there is no card height
         to protect, and "− 0 +" asks how many where ADD only asked whether. */
      if (addBtn) {
        addBtn.hidden = qty > 0;
        if (available) addBtn.disabled = isFull;
      }
      if (stepper) {
        var value = stepper.querySelector('[data-qty-value]');
        if (value) value.textContent = String(qty);

        var dec = stepper.querySelector('[data-qty-decrease]');
        if (dec) dec.disabled = qty === 0;

        var inc = stepper.querySelector('[data-qty-increase]');
        if (inc) inc.disabled = isFull;
      }
    }

    section.classList.toggle('is-bundle-full', isFull);
  }

  /* ── Discount tiers ───────────────────────────────────────── */

  function currentTier(state) {
    var found = null;
    var total = totalQuantity(state);
    for (var i = 0; i < state.tiers.length; i++) {
      if (total >= state.tiers[i].min) found = state.tiers[i];
    }
    return found;
  }

  function nextTier(state) {
    var total = totalQuantity(state);
    for (var i = 0; i < state.tiers.length; i++) {
      if (state.tiers[i].min > total) return state.tiers[i];
    }
    return null;
  }

  /* Which percentage applies depends on what is being bought. Both come off the
     full price; subscribe is NOT the one-time discount with more taken off it,
     because compounding cannot land on the required figures. */
  function discountPercent(state, frequency) {
    var tier = currentTier(state);
    if (!tier) return 0;
    var freq = frequency || state.frequency;
    return freq === 'subscribe' ? tier.percentSubscribe : tier.percent;
  }

  /* The subscribe rate to advertise right now.

     Shown on the subscribe card whichever purchase type is selected, because
     the card's job is to argue for subscribing — quoting the one-time rate on
     it would argue against. Below the minimum no tier is reached yet, so it
     falls back to the lowest tier's rate: the shopper is being told what
     subscribing is worth, and "0%" is not that. */
  function subscribePercent(state) {
    var tier = currentTier(state);
    if (tier) return tier.percentSubscribe;

    var lowest = null;
    for (var i = 0; i < state.tiers.length; i++) {
      if (!lowest || state.tiers[i].min < lowest.min) lowest = state.tiers[i];
    }
    return lowest ? lowest.percentSubscribe : 0;
  }

  /* Put the live percentage into a line of merchant copy.

     `[percent]` is the explicit token and wins wherever it appears. Failing
     that, the first percentage figure in the string is replaced — so copy
     already typed as "Save 20% on every subscription order" starts tracking the
     tier without anyone having to learn a token, and the number typed there
     survives as the fallback if the tiers ever go missing. */
  function withPercent(template, percent) {
    if (!template) return '';
    if (template.indexOf('[percent]') !== -1) {
      return template.replace(/\[percent\]/g, String(percent));
    }
    return template.replace(/\d+(?:\.\d+)?(?=\s*%)/, String(percent));
  }

  /* The subscribe card's heading and benefit lines. */
  function updateSubscribeCopy(section, state) {
    var pct = subscribePercent(state);
    var els = section.querySelectorAll('[data-subscribe-copy]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = withPercent(els[i].getAttribute('data-subscribe-copy'), pct);
    }
  }

  function unitWord(state, count) {
    return count === 1 ? state.unitNoun : state.unitNounPlural;
  }

  function fillTemplate(template, values) {
    var out = String(template || '');
    for (var key in values) {
      if (!Object.prototype.hasOwnProperty.call(values, key)) continue;
      out = out.split('[' + key + ']').join(values[key]);
    }
    return out;
  }

  /* The bar, the tier markers and the nudge underneath. This is what replaced
     the pack-size picker: instead of committing to a size up front, the shopper
     is told what the next discount is worth and how close they are to it. */
  function updateTierProgress(section, state) {
    var wrap = section.querySelector('[data-tier-section]');
    if (!wrap) return;

    var total = totalQuantity(state);
    var maxTierQty = intAttr(wrap, 'data-tier-max-qty', 0);
    if (maxTierQty <= 0) maxTierQty = state.maxQuantity || 1;

    var bar = section.querySelector('[data-tier-progress]');
    if (bar) {
      var pct = Math.max(0, Math.min(100, (total / maxTierQty) * 100));
      bar.style.width = pct.toFixed(1) + '%';
    }

    var reached = currentTier(state);
    for (var i = 0; i < state.tiers.length; i++) {
      var tier = state.tiers[i];
      tier.el.classList.toggle('is-reached', total >= tier.min);
      tier.el.classList.toggle('is-current', reached === tier);

      /* The ladder itself differs by purchase type — 10/20/30/35 one-time
         against 15/25/35/40 subscribed — so the marks cannot stay at whatever
         was rendered. */
      var saveEl = tier.el.querySelector('[data-tier-save]');
      if (saveEl) {
        saveEl.textContent =
          (state.frequency === 'subscribe' ? tier.percentSubscribe : tier.percent) + '%';
      }
    }

    var countEl = section.querySelector('[data-bundle-count]');
    if (countEl) {
      countEl.textContent = total + ' ' + unitWord(state, total);
    }

    var messageEl = section.querySelector('[data-tier-message]');
    if (!messageEl) return;

    var upcoming = nextTier(state);
    var text;

    if (upcoming) {
      var needed = upcoming.min - total;
      var template = total === 0
        ? section.getAttribute('data-message-empty')
        : section.getAttribute('data-message-next');
      text = fillTemplate(template || 'Add [count] more to save [percent]%', {
        count: needed,
        percent: state.frequency === 'subscribe' ? upcoming.percentSubscribe : upcoming.percent,
        tier: upcoming.label,
        units: unitWord(state, needed)
      });
    } else if (reached) {
      text = fillTemplate(
        section.getAttribute('data-message-max') || "Best value unlocked — you're saving [percent]%!",
        {
          count: 0,
          percent: state.frequency === 'subscribe' ? reached.percentSubscribe : reached.percent,
          tier: reached.label,
          units: unitWord(state, total)
        }
      );
    } else {
      text = '';
    }

    messageEl.textContent = text;
    messageEl.hidden = !text;
    messageEl.classList.toggle('is-complete', !upcoming && !!reached);
  }

  /* ── The price summary ────────────────────────────────────────
     Hidden until the bundle clears the minimum. Before that there is no price
     worth quoting — the shopper has not bought anything yet, and a total that
     climbs from one can is an argument against carrying on rather than for it.
     Once earned it shows what the bundle was, what it is, and the gap. */

  function updateSummary(section, state, totals) {
    var summary = section.querySelector('[data-summary]');
    if (!summary) return;

    var total = totalQuantity(state);
    var minQty = state.minQuantity || 1;
    var earned = total >= minQty;

    summary.hidden = !earned;
    if (!earned) return;

    var savings = totals.regular - totals.current;

    setText(section, '[data-summary-compare]', savings > 0 ? formatMoney(totals.regular) : '');
    setText(section, '[data-summary-price]', formatMoney(totals.current));

    var badge = section.querySelector('[data-summary-savings]');
    if (badge) {
      badge.hidden = savings <= 0;
      setText(section, '[data-summary-savings-amount]', savings > 0 ? formatMoney(savings) : '');
    }
  }

  function initFrequencySelector(section, state) {
    var radios = section.querySelectorAll('.oddit-section-bundle-builder__frequency-radio');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', handleFrequencyChange.bind(null, section, state));
    }
  }

  function handleFrequencyChange(section, state, e) {
    var radio = e.target;
    state.frequency = radio.value;

    var allOptions = section.querySelectorAll('.oddit-section-bundle-builder__frequency-option');
    for (var i = 0; i < allOptions.length; i++) {
      allOptions[i].classList.remove('oddit-section-bundle-builder__frequency-option--active');
    }

    var parentLabel = radio.closest('.oddit-section-bundle-builder__frequency-option');
    if (parentLabel) {
      parentLabel.classList.add('oddit-section-bundle-builder__frequency-option--active');
    }

    /* Prices follow the chosen frequency — and so do the cart lines, since a
       subscription is a different line from a one-time purchase of the same
       variant. */
    /* A full render rather than just the prices: the meter marks, the tier
       message and the CTA all read the selected purchase type now, and
       updating a subset of them is how they drift apart. */
    render(section, state);
    scheduleCartSync(section, state);
  }

  /* ── Pricing ──────────────────────────────────────────────────
     Prices used to be four typed-in pack prices, one per pack size. A bundle
     with no fixed size cannot be priced that way, so the total is built from
     the variants the shopper actually chose and the tier discount comes off
     that — which also means a price change in Shopify flows through on its own. */

  /* Shopify floors the discount PER UNIT, then multiplies by the quantity — it
     does not take the percentage off the order subtotal and round once. At
     $9.99 a can, 10% off is $0.999 of which only $0.99 comes off, so a can
     costs exactly $9.00 and three cost $27.00. The panel used to compute
     $29.97 x 0.9 = $26.97 and quote a price the checkout would not honour.

     Per UNIT, not per line: the mix cannot change the price. Verified against
     the live cart — 3 of one flavour and 3 different flavours both come to
     $27.00, and 6 as one line or three lines both come to $48.00. That matters
     beyond the arithmetic, because a mix-and-match bundle whose total moved
     with the flavour split would be indefensible to a shopper. */
  /* The discount is a percentage of the subtotal, rounded to the nearest cent,
     and THEN subtracted — not the subtotal multiplied by what is left.

     The two differ by a cent wherever the discount lands on a half: at five cans
     10%% of $49.95 is $4.995, which rounds to $5.00 off and a $44.95 total,
     while `round(4995 * 0.9)` gives $44.96. Every quantity here was measured
     against the live cart, and this is the form that reproduces all of them. */
  function discountUnits(units, pct) {
    var base = 0;
    for (var i = 0; i < units.length; i++) {
      base += units[i].price * units[i].qty;
    }
    if (pct <= 0) return base;
    return base - Math.round((base * pct) / 100);
  }

  function bundleTotals(state) {
    var section = state.section;
    var baseCents = 0;
    var regularCents = 0;
    var units = [];

    for (var productId in state.quantities) {
      if (!Object.prototype.hasOwnProperty.call(state.quantities, productId)) continue;
      var card = cardFor(section, productId);
      if (!card) continue;

      var qty = state.quantities[productId];
      var price = intAttr(card, 'data-variant-price', 0);
      var compare = intAttr(card, 'data-variant-compare-price', price);
      /* A variant with no compare-at price is not on sale, so its "was" price is
         simply its price — otherwise the savings line would read as negative. */
      if (compare < price) compare = price;

      baseCents += price * qty;
      regularCents += compare * qty;

      /* The plan's own per-unit price, so subscribe is quoted from what the
         cart will charge rather than from a percentage the panel re-derives.
         Looked up as though subscribe were selected — both prices are shown
         side by side, so the subscribe figure has to be right even while the
         shopper is still on one-time. */
      var planMatch = planMatchFor(
        state.frequency === 'subscribe' ? state : { frequency: 'subscribe', quantities: state.quantities, tiers: state.tiers, section: section },
        card
      );

      units.push({
        price: price,
        qty: qty,
        planPrice: planMatch && planMatch.price > 0 ? planMatch.price : null
      });
    }

    /* Both prices are always computed, because the panel shows them side by
       side — the shopper compares them before choosing. Each is taken off the
       full price rather than one off the other. */
    var oneTimeCents = discountUnits(units, discountPercent(state, 'one-time'));

    /* Subscribe is the sum of the plan prices when every line has one. That is
       not the same number as the percentage worked out over the subtotal —
       Shopify rounds the plan price per unit, so nine cans at 35% cost $58.41
       and not the $58.44 a subtotal calculation gives. Quoting the calculated
       figure would put the panel three cents above the checkout.

       If any line lacks a plan the whole bundle falls back to the percentage,
       because a total half of which is a real plan price and half of which is
       an estimate is worse than one that is consistently an estimate. */
    var subscribeCents = 0;
    var everyLinePlanned = units.length > 0;
    for (var u = 0; u < units.length; u++) {
      if (units[u].planPrice === null) { everyLinePlanned = false; break; }
      subscribeCents += units[u].planPrice * units[u].qty;
    }
    if (!everyLinePlanned) {
      subscribeCents = discountUnits(units, discountPercent(state, 'subscribe'));
    }

    return {
      regular: regularCents,
      oneTime: oneTimeCents,
      subscribe: subscribeCents,
      current: state.frequency === 'one-time' ? oneTimeCents : subscribeCents,
      /* The percentage for whichever type is selected — callers use this for the
         savings copy, so it has to follow the same split as the prices above. */
      percent: discountPercent(state)
    };
  }

  function setText(section, selector, value) {
    var els = section.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = value;
    }
  }

  function updatePricing(section, state) {
    var totals = bundleTotals(state);
    var empty = totalQuantity(state) === 0;

    setText(section, '[data-subscribe-compare]',
      !empty && totals.regular > totals.subscribe ? formatMoney(totals.regular) : '');
    setText(section, '[data-subscribe-price]', empty ? '' : formatMoney(totals.subscribe));
    setText(section, '[data-onetime-compare]',
      !empty && totals.regular > totals.oneTime ? formatMoney(totals.regular) : '');
    setText(section, '[data-onetime-price]', empty ? '' : formatMoney(totals.oneTime));

    state.currentPriceCents = totals.current;
    state.totals = totals;

    updateSummary(section, state, totals);
    updateShippingProgress(section, state);
  }

  /* ── Free-shipping progress ───────────────────────────────────
     Reads the running bundle total, and treats a tier that advertises free
     shipping as unlocking it outright — otherwise a 9-can bundle could show
     "Save 35% + Free Shipping" while the bar underneath still asked for more. */

  function updateShippingProgress(section, state) {
    var bar = section.querySelector('[data-shipping-progress]');
    var caption = section.querySelector('[data-shipping-text]');

    var thresholdDollars = parseFloat(
      String(section.getAttribute('data-free-shipping-threshold') || '').replace(/[^0-9.]/g, '')
    );
    var thresholdCents = isNaN(thresholdDollars) ? 0 : Math.round(thresholdDollars * 100);
    var current = state.currentPriceCents || 0;

    var tier = currentTier(state);
    /* Subscribe has its own answer: a subscribed six-pack comes to $44.95
       against a $45 threshold, so the threshold cannot be what decides it. */
    var tierUnlocks = !!(tier && (state.frequency === 'subscribe'
      ? tier.freeShippingSubscribe
      : tier.freeShipping));

    if (!thresholdCents && !tierUnlocks) {
      if (bar) bar.style.width = '0%';
      if (caption) caption.textContent = '';
      return;
    }

    var unlocked = tierUnlocks || (thresholdCents > 0 && current >= thresholdCents);
    var pct = unlocked ? 100 : Math.max(0, Math.min(100, (current / thresholdCents) * 100));
    if (bar) bar.style.width = pct.toFixed(1) + '%';

    if (caption) {
      var remaining = thresholdCents - current;
      /* "free shipping!" is semibold in the design, so the caption needs two
         runs rather than one flat string. Built as nodes, not innerHTML. */
      caption.textContent = '';
      caption.appendChild(
        document.createTextNode(
          unlocked ? "You've unlocked " : "You're " + formatMoney(remaining) + ' away from '
        )
      );
      var em = document.createElement('span');
      em.className = 'oddit-section-bundle-builder__shipping-text-em';
      em.textContent = 'free shipping!';
      caption.appendChild(em);
    }

    section.classList.toggle('has-free-shipping', unlocked);
  }

  /* ── Keeping the cart in step ─────────────────────────────────
     The bundle used to be assembled locally and posted in one go when the CTA
     was pressed. It is now built directly in the cart: every stepper tap writes
     through, and the button at the bottom only has to walk the shopper to
     checkout. That means a shopper who wanders off still has their bundle, and
     the cart icon agrees with the panel at every moment.

     Local state stays the source of truth and the cart is reconciled to it,
     rather than each tap issuing its own add/remove. Reconciling is what makes
     rapid tapping safe: whatever order the clicks land in, the next sync just
     drives the cart to the current numbers. */

  function showBundleError(section, message) {
    var el = section.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      /* Shopify puts the reason in the body — throwing on the status alone left
         a rejected call looking identical to no click at all. */
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error(
            (data && (data.description || data.message)) || 'Cart update failed: ' + r.status
          );
        }
        return data;
      });
    });
  }

  /* Only the variants this builder offers. Anything else in the cart belongs to
     the shopper and must survive untouched. */
  function managedVariantIds(section) {
    var ids = {};
    var rows = section.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i++) {
      var vid = rows[i].getAttribute('data-variant-id');
      if (vid) ids[String(vid)] = true;
    }
    return ids;
  }

  /* A cart line is identified by variant *and* selling plan: the same can
     bought once and bought on subscription are two different lines. */
  function lineKey(variantId, planId) {
    return String(variantId) + ':' + (planId ? String(planId) : '');
  }

  /* The subscribe options on a row, parsed once and cached on the element.
     Each is `{ id, price, percent }`, where price is what Shopify charges per
     unit on that plan and percent is how far below the variant price that is. */
  function rowPlans(row) {
    if (row._bbPlans) return row._bbPlans;

    var plans = [];
    var raw = row.getAttribute('data-selling-plans') || '';
    var parts = raw.split(',');

    for (var i = 0; i < parts.length; i++) {
      var bits = parts[i].split(':');
      if (bits.length < 3 || !bits[0]) continue;
      var price = parseInt(bits[1], 10);
      var percent = parseInt(bits[2], 10);
      plans.push({
        id: bits[0],
        price: isNaN(price) ? 0 : price,
        percent: isNaN(percent) ? 0 : percent
      });
    }

    row._bbPlans = plans;
    return plans;
  }

  /* Which subscribe option this row should be bought on, given how many cans
     are in the bundle.

     Recharge built one plan per tier, so the discount lives on the plan rather
     than on a cart discount — meaning the plan has to change as the bundle
     grows. The tier's subscribe percentage is what identifies it: a tier set to
     35% wants the plan that takes 35% off, whatever its id happens to be, so
     renaming or rebuilding the plans in Recharge does not break this.

     Falls back to the first plan on the variant, which is the right answer for
     a shop with only one. */
  function planMatchFor(state, row) {
    if (state.frequency !== 'subscribe') return null;

    var plans = rowPlans(row);
    if (!plans.length) return null;

    var tier = currentTier(state);
    var wanted = tier ? tier.percentSubscribe : 0;

    for (var i = 0; i < plans.length; i++) {
      if (plans[i].percent === wanted) return plans[i];
    }

    /* No plan cut to this tier. Take the deepest discount that does not exceed
       what the tier promises — overshooting would charge less than the panel
       quoted, and undershooting at least never surprises the shopper upward. */
    var best = null;
    for (var j = 0; j < plans.length; j++) {
      if (plans[j].percent > wanted) continue;
      if (!best || plans[j].percent > best.percent) best = plans[j];
    }
    return best || plans[0];
  }

  function planForRow(state, row) {
    if (state.frequency !== 'subscribe') return '';
    var match = planMatchFor(state, row);
    if (match) return match.id;
    return row.getAttribute('data-selling-plan-id') || '';
  }

  function desiredLines(section, state) {
    var want = {};
    for (var productId in state.quantities) {
      if (!Object.prototype.hasOwnProperty.call(state.quantities, productId)) continue;

      var row = cardFor(section, productId);
      if (!row) continue;

      var variantId = row.getAttribute('data-variant-id');
      if (!variantId) continue;

      /* The section resolves which variant a flavour is bought as. If the
         configured variant name matched nothing, say so rather than quietly
         buying whichever variant came first. */
      var unmatched = row.getAttribute('data-variant-unmatched');
      if (unmatched && window.console) {
        console.warn(
          '[bundle-builder] "' + row.getAttribute('data-product-title') +
          '" has no variant named "' + unmatched + '" — using "' +
          row.getAttribute('data-variant-title') + '" instead.'
        );
      }

      var planId = planForRow(state, row);
      if (state.frequency === 'subscribe' && !planId && window.console) {
        console.warn(
          '[bundle-builder] No selling plan on variant ' + variantId +
            '; it goes in as a one-time purchase.'
        );
      }

      var key = lineKey(variantId, planId);
      want[key] = (want[key] || 0) + state.quantities[productId];
    }
    return want;
  }

  function itemPlanId(item) {
    return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? String(item.selling_plan_allocation.selling_plan.id)
      : '';
  }

  /* How Shopify says a line key no longer matches anything. The wording differs
     by endpoint and none of it is worth showing a shopper, but it is the signal
     that the snapshot is stale rather than that the request was wrong. */
  var CART_MOVED = /no valid id or line parameter|cannot find line|line item not found|invalid line/i;

  function cartMoved(err) {
    return CART_MOVED.test((err && err.message) || '');
  }

  /* Most of what Shopify puts in a cart error's `description` is written to be
     shown: "All 5 Polar Pop are in your cart" tells a shopper exactly what
     happened and what to do about it, and replacing it with something vaguer
     would be a downgrade.

     The exceptions are the errors that describe the REQUEST rather than the
     cart — "no valid id or line parameter" and friends. Those mean nothing to
     anyone but whoever wrote the request, and one of them is what a shopper was
     reading under the checkout button. So this is a deny-list, not an
     allow-list: name the developer text, pass everything else through. */
  var DEVELOPER_TEXT = /parameter|invalid json|^cart error$|^cart update failed|^unexpected token|undefined/i;

  function shopperMessage(err) {
    var raw = ((err && err.message) || '').trim();
    if (!raw || CART_MOVED.test(raw) || DEVELOPER_TEXT.test(raw)) {
      return 'We could not update your cart. Please try again.';
    }
    return raw;
  }

  /* One pass: read the cart, work out the difference, apply it. */
  function syncCartOnce(section, state) {
    var managed = managedVariantIds(section);
    var want = desiredLines(section, state);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var changes = [];
        var seen = {};
        var items = (cart && cart.items) || [];

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (!managed[String(item.variant_id)]) continue;

          var key = lineKey(item.variant_id, itemPlanId(item));

          /* A second line for the same variant and plan can only be a duplicate
             — collapse it into the first rather than double-counting. */
          if (seen[key]) {
            changes.push({ id: item.key, quantity: 0 });
            continue;
          }
          seen[key] = true;

          var target = want[key] || 0;
          if (item.quantity !== target) changes.push({ id: item.key, quantity: target });
        }

        var adds = [];
        for (var key2 in want) {
          if (!Object.prototype.hasOwnProperty.call(want, key2)) continue;
          if (seen[key2]) continue;

          var parts = key2.split(':');
          var line = { id: Number(parts[0]), quantity: want[key2] };
          if (parts[1]) line.selling_plan = Number(parts[1]);
          adds.push(line);
        }

        /* /cart/change.js takes one line at a time, so those go in sequence;
           the additions batch into a single /cart/add.js. */
        var chain = Promise.resolve();
        changes.forEach(function (change) {
          chain = chain.then(function () { return postJSON('/cart/change.js', change); });
        });
        if (adds.length) {
          chain = chain.then(function () { return postJSON('/cart/add.js', { items: adds }); });
        }
        return chain;
      });
  }

  /* The cart can move between the read and the writes — the drawer on this page
     writes to it, and the writes themselves go one at a time. A key that has
     gone is not a failure, it is a stale plan: read again and recompute against
     what is actually there.

     Bounded, because a plan that keeps failing for a reason that merely looks
     like staleness would otherwise loop. Two extra passes is enough to absorb a
     concurrent write without turning a real fault into a spin. */
  function syncCart(section, state, attempt) {
    var tries = attempt || 0;

    return syncCartOnce(section, state).catch(function (err) {
      if (tries < 2 && cartMoved(err)) {
        if (window.console) {
          console.warn('[bundle-builder] cart moved mid-sync, recomputing', err.message);
        }
        return syncCart(section, state, tries + 1);
      }
      throw err;
    });
  }

  /* Read the cart back into the panel. Runs at load, so a shopper returning to
     the page sees the bundle they already have rather than an empty builder
     that would then add a second copy of everything; and after a failed sync,
     so the numbers on screen are the numbers in the cart. */
  function hydrateFromCart(section, state) {
    var managed = managedVariantIds(section);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var quantities = {};
        var sawPlan = false;
        var sawAny = false;

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (!managed[String(item.variant_id)]) continue;

          var row = section.querySelector(
            ROW_SELECTOR + '[data-variant-id="' + item.variant_id + '"]'
          );
          if (!row) continue;

          var productId = row.getAttribute('data-product-id');
          quantities[productId] = (quantities[productId] || 0) + item.quantity;
          sawAny = true;
          if (itemPlanId(item)) sawPlan = true;
        }

        /* Respect the cap even if the cart somehow holds more than it allows. */
        if (state.maxQuantity > 0) {
          var running = 0;
          for (var pid in quantities) {
            if (!Object.prototype.hasOwnProperty.call(quantities, pid)) continue;
            var room = state.maxQuantity - running;
            if (room <= 0) { delete quantities[pid]; continue; }
            quantities[pid] = Math.min(quantities[pid], room);
            running += quantities[pid];
          }
        }

        state.quantities = quantities;
        /* A cart already on subscription should not silently flip to one-time
           the moment the shopper touches a stepper. */
        if (sawAny) setFrequency(section, state, sawPlan ? 'subscribe' : 'one-time');
        render(section, state);
      })
      .catch(function (err) {
        if (window.console) console.warn('[bundle-builder] could not read the cart', err);
      });
  }

  function setFrequency(section, state, value) {
    state.frequency = value;

    var radios = section.querySelectorAll('.oddit-section-bundle-builder__frequency-radio');
    for (var i = 0; i < radios.length; i++) {
      var match = radios[i].value === value;
      radios[i].checked = match;

      var label = radios[i].closest('.oddit-section-bundle-builder__frequency-option');
      if (label) {
        label.classList.toggle('oddit-section-bundle-builder__frequency-option--active', match);
      }
    }
  }

  /* Taps come in bursts — six presses of + should be one round trip, not six.
     The timer coalesces them; the chain guarantees two syncs never overlap and
     race each other's line keys. */
  function scheduleCartSync(section, state) {
    if (state.syncTimer) {
      clearTimeout(state.syncTimer);
      state.syncTimer = null;
    }
    section.classList.add('is-cart-syncing');

    var supersededResolve = state.syncResolve;

    state.syncPending = new Promise(function (resolve) {
      state.syncResolve = resolve;
      state.syncTimer = setTimeout(function () {
        state.syncTimer = null;
        state.syncResolve = null;
        resolve(runCartSync(section, state));
      }, 350);
    });

    /* The promise this one replaces still has to settle. Its timer was just
       cancelled, so anything waiting on it — a checkout click that arrived
       mid-debounce — would otherwise wait forever. It resolves to the sync that
       took its place, which is the answer it was waiting for anyway. */
    if (supersededResolve) supersededResolve(state.syncPending);

    return state.syncPending;
  }

  function runCartSync(section, state) {
    state.syncChain = (state.syncChain || Promise.resolve())
      .then(function () { return syncCart(section, state); })
      .then(function () {
        showBundleError(section, '');
        /* Refresh, never open: the drawer sliding out on every stepper tap
           would bury the builder the shopper is still using. This only redraws
           the drawer's contents and fires cart:updated, which is what moves the
           header count. */
        if (window.OdditCartDrawer && window.OdditCartDrawer.refreshCart) {
          return window.OdditCartDrawer.refreshCart();
        }
      })
      .catch(function (err) {
        showBundleError(section, shopperMessage(err));
        if (window.console) console.error('[bundle-builder]', err);
        /* Whatever went wrong — sold out mid-session, a stale line — the panel
           must not keep claiming a bundle the cart does not hold. */
        return hydrateFromCart(section, state);
      })
      .then(function () {
        section.classList.remove('is-cart-syncing');
      });

    return state.syncChain;
  }

  /* Checkout cannot leave a debounced tap behind, so a pending sync is run now
     rather than waited out. */
  function flushCartSync(section, state) {
    if (state.syncTimer) {
      clearTimeout(state.syncTimer);
      state.syncTimer = null;

      var pending = runCartSync(section, state);
      /* Same contract as above: the debounced promise settles with the sync
         that ran in its place rather than being abandoned. */
      if (state.syncResolve) {
        state.syncResolve(pending);
        state.syncResolve = null;
      }
      return pending;
    }
    return state.syncChain || Promise.resolve();
  }

  function checkoutUrl(section, state) {
    var tier = currentTier(state);
    var code = tier && (state.frequency === 'subscribe'
      ? tier.discountCodeSubscribe
      : tier.discountCode);
    /* The builder only ever displays the tier discount — Shopify is what
       actually applies it. A code on the tier is carried through so the price
       at checkout matches the price on the button; without one, the merchant
       needs an automatic discount configured instead. */
    return code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }

  function handleCheckout(section, state) {
    var btn = section.querySelector('.oddit-section-bundle-builder__cta-button');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    flushCartSync(section, state)
      .then(function () {
        var url = checkoutUrl(section, state);

        /* Announced before leaving, so analytics can record a begin-checkout
           with the bundle that was actually built — once the browser navigates
           there is nothing left on the page to read it from. */
        if (typeof window.CustomEvent === 'function') {
          document.dispatchEvent(
            new CustomEvent('oddit:bundle-checkout', {
              detail: {
                url: url,
                quantity: totalQuantity(state),
                totalCents: state.totals ? state.totals.current : null,
                discountCode: (function (t) {
                  if (!t) return '';
                  return state.frequency === 'subscribe'
                    ? (t.discountCodeSubscribe || '')
                    : (t.discountCode || '');
                })(currentTier(state))
              }
            })
          );
        }

        window.location.href = url;
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  function updateCTAButton(section, state) {
    var ctaBtn = section.querySelector('.oddit-section-bundle-builder__cta-button');
    if (!ctaBtn) return;

    var label = ctaBtn.querySelector('[data-button-label]');
    var priceEl = ctaBtn.querySelector('[data-button-price]');
    var total = totalQuantity(state);
    /* One bundle, one minimum — the button no longer has to match a pack size
       the shopper picked, only clear the smallest bundle the merchant sells. */
    var minQty = state.minQuantity || 1;
    var remaining = minQty - total;

    if (remaining <= 0) {
      /* Ready: the cans are already in the cart, so this is a doorway to
         checkout. It carries the price because that is the number the shopper
         is agreeing to, and seeing it on the button is what stops the total
         being a surprise one screen later. */
      ctaBtn.disabled = false;
      ctaBtn.classList.add('is-ready');
      if (label) {
        label.textContent = section.getAttribute('data-cta-text-ready') || 'Try Zapz Now';
      }
      if (priceEl) {
        priceEl.textContent = state.totals ? formatMoney(state.totals.current) : '';
        priceEl.hidden = !state.totals;
      }
      return;
    }

    /* Short: the button counts down what is still needed rather than repeating
       a fixed "select your flavors" that stops being true after the first tap. */
    ctaBtn.disabled = true;
    ctaBtn.classList.remove('is-ready');
    if (label) {
      label.textContent = fillTemplate(
        section.getAttribute('data-cta-text') || 'Add [count] more [units]',
        { count: remaining, units: unitWord(state, remaining) }
      );
    }
    if (priceEl) {
      priceEl.textContent = '';
      priceEl.hidden = true;
    }
  }

  function initAccordions(section) {
    var accordions = section.querySelectorAll('.oddit-section-bundle-builder__accordion');
    for (var i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener('toggle', handleAccordionToggle);
    }
  }

  function handleAccordionToggle(e) {
    var details = e.target;
    if (!details.open) return;

    var parent = details.closest('.oddit-section-bundle-builder__accordions');
    if (!parent) return;

    var siblings = parent.querySelectorAll('.oddit-section-bundle-builder__accordion');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== details && siblings[i].open) {
        siblings[i].open = false;
      }
    }
  }

  function destroySection(section) {
    sectionState.delete(section);
  }

  /* ── Public API ───────────────────────────────────────────────
     For anything on the page that needs to put a flavour in the bundle — the
     single-flavour PDP under this section does — so it never has to reach into
     the builder's markup and classes to do it. */

  function findSectionFor(productId) {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      if (sectionState.has(sections[i]) && cardFor(sections[i], productId)) return sections[i];
    }
    return null;
  }

  window.OdditBundleBuilder = {
    getQuantity: function (productId) {
      var section = findSectionFor(productId);
      if (!section) return 0;
      return sectionState.get(section).quantities[productId] || 0;
    },
    add: function (productId, delta) {
      var section = findSectionFor(productId);
      if (!section) return false;
      changeQuantity(section, sectionState.get(section), productId, delta || 1);
      return true;
    },
    setQuantity: function (productId, qty) {
      var section = findSectionFor(productId);
      if (!section) return false;
      setQuantity(section, sectionState.get(section), productId, qty);
      return true;
    },
    isAvailable: function (productId) {
      var section = findSectionFor(productId);
      if (!section) return false;
      var card = cardFor(section, productId);
      return !!card && card.getAttribute('data-available') !== 'false';
    },
    isFull: function (productId) {
      var section = productId ? findSectionFor(productId) : document.querySelector(SECTION_SELECTOR);
      if (!section || !sectionState.has(section)) return false;
      var state = sectionState.get(section);
      return state.maxQuantity > 0 && totalQuantity(state) >= state.maxQuantity;
    },
    hasProduct: function (productId) {
      return !!findSectionFor(productId);
    }
  };

  document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
    initSection(section);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
